import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

// Opcoes dos filtros de negocio (etiqueta, origem, produto) do quadro do funil e do relatorio: etiquetas da conta,
// origens configuradas nos funis informados (uniao por chave quando sao varios) e produtos ativos.
export function useKanbanFilterOptions({ boards, products }) {
  const { t } = useI18n();
  const accountLabels = useMapGetter('labels/getLabels');

  const labelOptions = computed(() => [
    {
      label: t('KANBAN.FILTERS.ALL_LABELS'),
      value: 'all',
      icon: 'i-lucide-tag',
    },
    ...(accountLabels.value || []).map(label => ({
      label: label.title,
      value: label.title,
      icon: 'i-lucide-tag',
    })),
  ]);

  const sourceOptions = computed(() => {
    const sources = new Map();
    boards.value.forEach(board =>
      (board?.settings?.sources || []).forEach(source => {
        const key = String(source.key);
        if (!sources.has(key)) sources.set(key, source);
      })
    );
    return [
      {
        label: t('KANBAN.FILTERS.ALL_SOURCES'),
        value: 'all',
        icon: 'i-lucide-radio',
      },
      ...[...sources].map(([key, source]) => ({
        label: source.name || source.key,
        value: key,
        icon: 'i-lucide-radio',
      })),
    ];
  });

  const productOptions = computed(() => [
    {
      label: t('KANBAN.FILTERS.ALL_PRODUCTS'),
      value: 'all',
      icon: 'i-lucide-package',
    },
    ...(products.value || [])
      .filter(product => !product.archived)
      .map(product => ({
        label: product.name,
        value: String(product.id),
        icon: 'i-lucide-package',
      })),
  ]);

  return { labelOptions, sourceOptions, productOptions };
}
